$(document).ready(function(){
  $('.js-mv-slider').slick({
    fade: true,
    speed: 1500,
    autoplaySpeed: 3000,
    arrows: false,
    dots: false,
    autoplay: true,
    slidesToShow: 1,
    slidesToScroll: 1,
    infinite: true,
    pauseOnHover: false // ここを追加します
  });
});